import React from 'react';
import { About, Footer, Header, Skills, Achievements, Work, Experience } from '../container';

const Home = () => {
  return (
    <>
      <Header />
      <About />
      <Skills />
      <Experience />
      <Work />
      <Achievements />
      <Footer />
    </>
  );
};

export default Home; 